var map = {
	"./wifi-0.png": "17a0",
	"./wifi-1.png": "4830",
	"./wifi-2.png": "7f11",
	"./wifi-3.png": "df7a",
	"./wifi-4.png": "b5e6",
	"./wifi-no.png": "3e54"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6a95";